import { Component, ElementRef, ViewChild, AfterViewInit, HostListener, Input } from '@angular/core'
import { fromEvent } from 'rxjs'
import { debounceTime } from 'rxjs/operators'

@Component({
    selector: 'app-overflow-container',
    templateUrl: 'overflow-container.html'
})
export class OverflowContainerComponent implements AfterViewInit {

    @Input() indentArrows = true
    @Input() useArrows = [true, true]
    @Input() useGradients = [true, true]

    el: HTMLElement
    start: boolean
    end: boolean
    overflowAmountRight: number

    @ViewChild('overflowContainer') overflowContainer: ElementRef

    constructor() {
        fromEvent(window, 'resize')
            .pipe(debounceTime(300))
            .subscribe(() => {
                this.setPositions()
            })
    }

    ngAfterViewInit(): void {
        this.setPositions()
    }

    setPositions() {
        this.el = this.overflowContainer.nativeElement
        this.start = this.el.scrollLeft === 0
        this.end = (this.el.scrollLeft + this.el.offsetWidth) >= this.el.scrollWidth - 5
        this.overflowAmountRight = Math.abs(this.el.offsetWidth - (this.el.scrollWidth - this.el.scrollLeft))
    }

    onScroll() {
        this.setPositions()
    }

    scrollForwards() {
        const scrollAmount = this.overflowAmountRight > this.el.offsetWidth ? this.el.offsetWidth : this.overflowAmountRight
        this.scroll(scrollAmount)
    }

    scrollBackwards() {
        const scrollAmount = this.el.scrollLeft > this.el.offsetWidth ? this.el.offsetWidth : this.el.scrollLeft
        this.scroll(-scrollAmount)
    }

    scroll(left: number) {
        this.el.scrollBy({
            left,
            top: 0,
            behavior: 'smooth'
        })
    }
}
